import { HandCoins } from "lucide-react";
import { tryValue } from "../lib/format";
import { fmtDisplay } from "../lib/currency";

export default function PayerSummary({ collections, rate = 0, currency = "TRY", rates = {} }) {
  const f = value => fmtDisplay(value, currency, rates);
  const map = new Map();
  collections.forEach(c => {
    const key = c.payer || "Belirtilmedi";
    const row = map.get(key) || { payer: key, total: 0, count: 0, methods: new Set() };
    row.total += tryValue(c, rate);
    row.count += 1;
    row.methods.add(c.method);
    map.set(key, row);
  });
  const rows = [...map.values()].sort((a, b) => b.total - a.total);
  const total = rows.reduce((sum, r) => sum + r.total, 0);

  return (
    <section className="panel payer-summary" data-testid="payer-summary">
      <div className="panel-head">
        <div>
          <p className="eyebrow">ÖDEYEN BAZINDA</p>
          <h3>Kimden ne kadar tahsil edildi</h3>
        </div>
        <HandCoins size={18}/>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr><th>Ödeyen</th><th>Yöntemler</th><th className="right">Adet</th><th className="right">Tahsil edilen</th><th className="right">Pay</th></tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.payer} data-testid={`payer-summary-row-${r.payer}`}>
                <td><b>{r.payer}</b></td>
                <td>{[...r.methods].map(m => <span key={m} className="group-tag">{m}</span>)}</td>
                <td className="right">{r.count}</td>
                <td className="right amount income" data-testid={`payer-total-${r.payer}`}>{f(r.total)}</td>
                <td className="right"><b>%{total ? Math.round((r.total / total) * 100) : 0}</b></td>
              </tr>
            ))}
          </tbody>
          {!!rows.length && (
            <tfoot>
              <tr data-testid="payer-summary-total">
                <td colSpan={2}><b>Toplam</b></td>
                <td className="right">{rows.reduce((s, r) => s + r.count, 0)}</td>
                <td className="right amount income">{f(total)}</td>
                <td className="right"><b>%100</b></td>
              </tr>
            </tfoot>
          )}
        </table>
        {!rows.length && <div className="empty-table">Bu dönemde tahsilat kaydı yok.</div>}
      </div>
    </section>
  );
}
